var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("OnClickOutside", { attrs: { do: _vm.close } }, [
    _c(
      "div",
      { staticClass: "base-select", class: { "is-active": _vm.isOpen } },
      [
        _c(
          "button",
          {
            ref: "button",
            staticClass: "base-select__input",
            attrs: { type: "button", disabled: _vm.disabled },
            on: {
              click: function ($event) {
                _vm.isOpen ? _vm.close() : _vm.open()
              },
              keydown: [
                _vm.handleKeydown,
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  )
                    return null
                  return _vm.close.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp",
                    ])
                  )
                    return null
                  return _vm.highlightPrev.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown",
                    ])
                  )
                    return null
                  return _vm.highlightNext.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                  return _vm.selectHighlighted.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                  )
                    return null
                  return _vm.close()
                },
              ],
            },
          },
          [
            _vm.value
              ? _c(
                  "span",
                  { staticClass: "base-select__value" },
                  [
                    _vm._t(
                      "value",
                      function () {
                        return [_vm._v(_vm._s(_vm.value))]
                      },
                      { value: _vm.value }
                    ),
                  ],
                  2
                )
              : _c("span", { staticClass: "base-select__placeholder" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t?.(_vm.placeholder, _vm.l10n_options) ||
                        _vm.placeholder
                    )
                  ),
                ]),
            _vm._v(" "),
            _c("span", { staticClass: "base-select__arrow-wrapper" }, [
              _c("span", { staticClass: "base-select__arrow" }, [
                _c(
                  "svg",
                  {
                    staticClass: "b-icon b-icon-chevron-down",
                    attrs: { width: "16", height: "16" },
                  },
                  [
                    _c("use", {
                      attrs: {
                        "xlink:href":
                          "/static/_v1/pd/svg-sprites/global.svg#icon-chevron-down",
                      },
                    }),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen && !_vm.disabled,
                expression: "isOpen && !disabled",
              },
            ],
            ref: "dropdown",
            staticClass: "base-select__dropdown",
          },
          [
            _vm.filterFunction
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search,
                      expression: "search",
                    },
                  ],
                  ref: "search",
                  staticClass: "base-select__search",
                  attrs: {
                    placeholder:
                      _vm.$t?.("Найти...", _vm.l10n_options) || "Найти...",
                  },
                  domProps: { value: _vm.search },
                  on: {
                    keydown: [
                      _vm.handleKeydown,
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape",
                          ])
                        )
                          return null
                        return _vm.close.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "up", 38, $event.key, [
                            "Up",
                            "ArrowUp",
                          ])
                        )
                          return null
                        return _vm.highlightPrev.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "down", 40, $event.key, [
                            "Down",
                            "ArrowDown",
                          ])
                        )
                          return null
                        return _vm.highlightNext.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                        return _vm.selectHighlighted.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        )
                          return null
                        $event.preventDefault()
                      },
                    ],
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.search = $event.target.value
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "base-select__scroller" }, [
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.filteredOptions.length > 0,
                      expression: "filteredOptions.length > 0",
                    },
                  ],
                  ref: "options",
                  staticClass: "base-select__options",
                },
                [
                  _vm._t(
                    "item",
                    function () {
                      return _vm._l(_vm.filteredOptions, function (option, i) {
                        return _c(
                          "li",
                          {
                            key: i,
                            staticClass: "base-select__option",
                            class: {
                              "is-active": i === _vm.highlightedIndex,
                              "is-selected": _vm.value === option,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.select(option)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(option) +
                                "\n            "
                            ),
                          ]
                        )
                      })
                    },
                    {
                      options: _vm.options,
                      select: _vm.select,
                      filteredOptions: _vm.filteredOptions,
                      value: _vm.value,
                      highlightedIndex: _vm.highlightedIndex,
                    }
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.filteredOptions.length === 0,
                      expression: "filteredOptions.length === 0",
                    },
                  ],
                  staticClass: "base-select__empty",
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t?.("Совпадений не найдено", _vm.l10n_options) ||
                          "Совпадений не найдено"
                      ) +
                      "\n          "
                  ),
                  _vm.search.length
                    ? _c("span", { staticClass: "base-select__search-text" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t?.("для", _vm.l10n_options) || "для") +
                            ' "'
                        ),
                        _c("b", [_vm._v(_vm._s(_vm.search))]),
                        _vm._v('"'),
                      ])
                    : _vm._e(),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }